import * as React from 'react';
import {ControlButton, TscButtonType} from '@techsmith/tsc-cloud-style-guide';
import Constants from '../../globals/Constants';
import Strings from '../../globals/Strings';
import ReviewRouterService from '../../services/ReviewRouterService/ReviewRouterService';
import Store from '../../redux/Store';
import ReviewVersionModel from '../../types/ReviewVersionModel';

export default ({title, text1, text2, text3, statusCode, headerSection, versionNotFound}: ErrorPageProps) => {
   const getText = () => {
      if (versionNotFound && Store.getState().currentReview) {
         return Strings.labels.versions.versionNotFound;
      } else if (text2) {
         return <div>
                  <span>{text1}</span>
                  <a href={Constants.siteLinks.support} target="_blank" title={text2}>{text2}</a>
                  <span>{text3}</span>
               </div>;
      } else {
         return text1;
      }
   };

   const headerText = versionNotFound && Store.getState().currentReview ? Strings.labels.versions.versionNotFoundHeader : title;

   return (
      <div className="error-page-wrapper">
         {headerSection}
         <div className="error-page-content">
            <h3 className="error-status-code">{statusCode}</h3>
            <h3 className="error-page-header">{headerText}</h3>
            <div className="error-page-text">{getText()}</div>
            {!versionNotFound || !Store.getState().currentReview && <ControlButton buttonType={TscButtonType.secondary}
                           title={Strings.labels.backToHomeButton}
                           label={Strings.labels.backToHomeButton}
                           href={'/'}
                           testId="back-to-home-button" />}
            {versionNotFound && Store.getState().currentReview && <div className="go-to-latest-version-button">
            <ControlButton buttonType={TscButtonType.primary}
                  label={Strings.labels.versions.goToLatestVerboseButtonText}
                  href={ReviewRouterService.createCanonicalReviewUrl(Store.getState().currentReview.Id, Store.getState().currentReview.ReviewVersions.filter((ver: ReviewVersionModel) => !ver.IsDeleted).pop().VersionNumber)}
                  testId="go-to-latest-version-button" />
            </div>}
         </div>
      </div>
   );
};

export interface ErrorPageProps {
   title: string;
   text1: string;
   text2?: string;
   text3?: string;
   statusCode: number;
   headerSection: JSX.Element;
   versionNotFound?: boolean;
}
